
import { Typography } from "antd";
import CommonView, { CommonViewProps } from "../../../../components/CommonView/CommonView";
import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";
import moment from "moment";
import { useState } from "react";
import dayjs from "dayjs";
const { Title, Text } = Typography;

const Quarters = () => {
    const [selectedId, onSelectId] = useState<string | null>(null);
    const [form, setForm] = useState<any>(null);

    const FiscalYearConfig: MasterConfigs = {
        api: () => '/fiscal-year',
        title: 'Fiscal Year',
        isActionTab: true,
        modalTitle: (action) => `${action} ${FiscalYearConfig.title}`,
        getFormColumns: () => {
            return [
                {
                    label: 'Name',
                    name: 'name',
                    type: 'text',
                    rules: [{ required: true, message: 'Name is required' }],
                },
                {
                    label: 'Start Date',
                    name: 'startDate',
                    type: 'date',
                    rules: [{ required: true, message: 'Start Date is required' }],
                },
                {
                    label: 'End Date',
                    name: 'endDate',
                    type: 'date',
                    rules: [{ required: true, message: 'End Date is required' }],
                },
                {
                    label: 'Description',
                    name: 'description',
                    type: 'textarea',
                    span: 16,
                }
            ];
        },
        combo: [],
        actions: [
            { name: 'Add Fiscal Year', actionType: 'Add' }
        ],
    };

    const Quarters: MasterConfigs = {
        api: () => '/quarters',
        queryParams: {
            fiscalYear: selectedId
        },
        title: 'Quarter',
        isActionTab: true,
        setForm: (formInstance) => {
            setForm(formInstance);
        },
        modalTitle: (action) => `${action} ${Quarters.title}`,
        getColumns: () => {
            return [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    key: 'name',
                    width: 150
                },
                {
                    title: 'Fiscal Year',
                    dataIndex: 'fiscalYear',
                    key: 'fiscalYear',
                    render: (fiscalYear) => {
                        return fiscalYear && fiscalYear.name;
                    },
                    width: 150
                },
                {
                    title: 'Start Date',
                    dataIndex: 'startDate',
                    key: 'startDate',
                    render: (date) => {
                        return new Date(date).toDateString();
                    },
                },
                {
                    title: 'End Date',
                    dataIndex: 'endDate',
                    key: 'endDate',
                    render: (date) => {
                        return new Date(date).toDateString();
                    }
                },
                {
                    title: 'Created On',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    width: 150,
                    render: (date) => {
                        return new Date(date).toDateString();
                    }
                }
            ];
        },
        getFormColumns: () => {
            return [
                {
                    label: 'Name',
                    name: 'name',
                    type: 'text',
                    rules: [{ required: true, message: 'Name is required' }],
                },
                { span: 16 },
                {
                    label: 'Fiscal Year',
                    name: 'fiscalYear',
                    isCombo: true,
                    type: 'select',
                    inputProps: {
                        placeholder: '2025-2026',
                    },
                    rules: [{ required: true, message: 'Fiscal Year is required' }],
                },
                {
                    label: 'Start Date',
                    name: 'startDate',
                    type: 'date',
                    rules: [{ required: true, message: 'Start Date is required' }],
                    dateProps: {
                        onChange: (date, dateString) => {
                            if (!form) return;
                            if (!date) {
                                form.setFieldValue('endDate', null);
                                return;
                            }
                            const startDate = dayjs(date);
                            const endDate = startDate.add(2, 'months').endOf('month');
                            form.setFieldValue('endDate', endDate);
                        },
                    },
                },
                {
                    label: 'End Date',
                    name: 'endDate',
                    type: 'date',
                    rules: [{ required: true, message: 'End Date is required' }],
                },
                {
                    label: 'Description',
                    name: 'description',
                    type: 'textarea',
                    span: 16,
                }
            ];
        },
        combo: [
            {
                name: 'fiscalYear',
                api: '/fiscal-year',
                render: (text) => text.name,
                idKey: '_id'
            }
        ],
        actions: [
            { name: 'Add Quarter', actionType: 'Add' }
        ],
    };


    const commonViewProps: CommonViewProps = {
        listProps: {
            height: 300,
        },
        config: FiscalYearConfig,
        componentConfig: {
            buttonName: 'Fiscal Year',
            title: 'Fiscal Year',
            subTitle: 'Manage Fiscal Year',
            cardTitle: 'Fiscal Year',
            emptyDescription: 'Please select a Fiscal Year to view',
            renderListItem: (item) => {
                return <div onClick={(e) => onSelectId(item?._id)}>
                    <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item.name}</Title>
                    <Text type="secondary">{moment(item?.startDate).format('MMMM Do YYYY')} - {moment(item?.endDate).format('MMMM Do YYYY')}</Text>
                </div>
            },
            renderComponent: (record) => {
                return <MasterComponent config={Quarters} />
            }
        }
    }

    return (
        <CommonView {...commonViewProps} />
    );
}

export default Quarters;